'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$32(evaluator$21) {
  this.M0 = null;
  this.M0 = evaluator$21;
}
export { $c_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$32 as $c_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$32 };
$p = $c_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$32.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$32;
/** @constructor */
function $h_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$32() {
}
export { $h_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$32 as $h_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$32 };
$h_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$32.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.M0.h();
  return ($j_java$002elang$002e$002dObject.$isInt(v) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$32 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$32, "samples.Sealed$package$$anon$6$$anon$28$$anon$32", ({
  qy: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$32 as $d_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$32 };
